import React, { FC } from "react";
import { TableRow as MuiTableRow, TableRowProps } from "@mui/material";

interface CustomTableRowProps {
  evenOdd?: boolean;
}

const TableRow: FC<TableRowProps & CustomTableRowProps> = (props) => (
  <MuiTableRow {...props} />
);

export default TableRow;
